import { useMutation, useQueryClient } from "@tanstack/react-query";
import { tournamentApi } from "@bw/shared/api";
import { queryKeys } from "../../../common/query/queryClient";

/** Reconciles the persisted charge before the player may choose another card. */
export function useAbandonRegistrationAttempt(
  tournamentId: string | undefined,
  expectedCheckoutId?: string,
) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (drawId: string) =>
      tournamentApi.abandonRegistrationAttempt(drawId, expectedCheckoutId),
    onSuccess: () => {
      const id = tournamentId ?? "";
      void queryClient.invalidateQueries({
        queryKey: queryKeys.tournaments.registrationsMine(id),
      });
      void queryClient.invalidateQueries({
        queryKey: queryKeys.tournaments.eligibility(id),
      });
      void queryClient.invalidateQueries({
        queryKey: queryKeys.tournaments.events(id),
      });
    },
    onSettled: async () => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: queryKeys.tournaments.myRegistrationPayments(),
        }),
        queryClient.invalidateQueries({
          queryKey: queryKeys.tournaments.myRegistrations(),
        }),
      ]);
    },
  });
}
